import { render, staticRenderFns } from "./AuthCheck.vue?vue&type=template&id=9a05ff44&scoped=true&"
import script from "./AuthCheck.vue?vue&type=script&lang=ts&"
export * from "./AuthCheck.vue?vue&type=script&lang=ts&"
import style0 from "./AuthCheck.vue?vue&type=style&index=0&id=9a05ff44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a05ff44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
